import { optionTitle_subscriptionActions } from 'owa-locstrings/lib/strings/optiontitle_subscriptionactions.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const BrandsSubscriptionsOption: LazyOption = createLazyOption(
    {
        key: 'brandsSubscriptionsOption',
        titleStringKey: optionTitle_subscriptionActions,
        searchTermsStringKey: optionTitle_subscriptionActions,
        hideTitleInFullOptions: true,
        isHidden: () => !isConsumer(),
    },
    lazyFullModule,
    m => m.default
);
export default BrandsSubscriptionsOption;
